import React from 'react'

export default function BuyLocation({propData}) {
  return (
     <div className="property-map-block">
                <div className="row">
                  <div className="col-12">
                    <div className="property-map-content property-details-block">
                      <h3>Location</h3>

                      {/* <img src="/location-map.png" alt="location-map" /> */}
                      <div className="map">
                        <iframe
                          src={propData?.propertyDTO?.mapUrl}
                          allowFullScreen
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          className="contact-map "
                          title="Location for Property"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  )
}
